import './Background.scss'
import classnames from 'classnames'
import React from 'react'

const Background = ({ src, className }) => {
  return (
    <div
      className={classnames('Background', className)}
      style={{ backgroundImage: `url(${src})` }}
    />
  )
}

Background.displayName = 'Background'

export default Background



// WEBPACK FOOTER //
// ./src/lib/Background.js